module.exports = __webpack_public_path__ + "img/2023-04.d90be47b.jpg";